/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Input_Position_Y_Move_DownInputs */



/**
* | output |
* | --- |
* | "Move Down 1 Line" |
*
* @param {Input_Position_Y_Move_DownInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const input_position_y_move_down = /** @type {((inputs?: Input_Position_Y_Move_DownInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Input_Position_Y_Move_DownInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Déplacer Vers le Bas de 1 Ligne")
	if (locale === "de") return /** @type {LocalizedString} */ ("Eine Zeile nach unten gehen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Spostati di 1 riga verso il basso")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Переместитесь на одну строку вниз.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Bajar 1 línea")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("向下移动一行")
	if (locale === "ja") return /** @type {LocalizedString} */ ("1行下に移動")
	if (locale === "hi") return /** @type {LocalizedString} */ ("एक पंक्ति नीचे जाएं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Desça uma linha")
	return /** @type {LocalizedString} */ ("Move Down 1 Line")
});